import styled, { css } from 'styled-components';
import {
  EgyptianNavigationProps,
  StickyNavigationCSSProps,
} from '../types/Navigation.types';

export const StickyNavigationCSS = css<StickyNavigationCSSProps>`
  position: sticky;
  top: 0;
  z-index: 100;

  @media (min-width: 1025px) {
    top: ${({ top }) => top};
  }
`;

export const NavigationWrapper = styled.div`
  ${StickyNavigationCSS}

  header {
    [class^='MainBarstyle__Container-sc'] {
      [class^='SimpleGridstyle__SimpleGrid-sc'] {
        > div:first-child {
          button {
            margin-left: 0;
            margin-inline-start: 12px;
          }
        }

        @media (max-width: 1024px) {
          > div:last-child {
            nav {
              justify-content: flex-end;
            }
          }
        }
      }
    }
  }

  span {
    [class^='SideNavigationstyle__SideNavigation-sc'] {
      direction: ltr;
    }
  }

  [class*='SideNavigationListstyle__MenuLink-sc']:focus:not(:focus-visible) {
    outline: none;
    box-shadow: none;
  }

  [class*='SideNavigationListstyle__MenuLink-sc']:focus-within:not(:focus-visible) {
    outline: none;
    box-shadow: none;
  }
`;

export const EgyptianNavigationWrapper = styled.div<EgyptianNavigationProps>`
  [class^='TopBarstyle__TopBar-sc'] {
    background-color: #333;

    [class^='TopBarstyle__Container-sc'] {
      [class^='SimpleGridstyle__SimpleGrid-sc'] {
        [class^='SimpleGridstyle__SimpleGridColumn-sc'] {
          padding: 0 15px;
          margin: 0 auto;
          width: 100%;

          @media (min-width: 992px) {
            max-width: 960px;
          }
          @media (min-width: 1200px) {
            max-width: 1140px;
          }

          [class^='TopBarstyle__LinksWrapper-sc'] {
            ul {
              li:nth-child(${({ selectedIndex }) => selectedIndex}) {
                button {
                  background-color: #fff;
                  color: #333;
                }
              }

              li {
                margin-right: 2.5px;

                button {
                  background-color: #333;
                  color: #ccc;
                  font-weight: 400;
                  font-size: 0.8rem;
                  line-height: 1.5;
                  padding: 4px 20px;

                  :hover {
                    background-color: #fff;
                    color: #333;
                  }
                }

                [class^='LinkListstyle__DividerWrapper-sc'] {
                  display: none;
                }
              }
            }
          }
        }
      }
    }
  }
`;
